import TutorialImage4 from "@/assets/images/tutorial-image-4.png";
import { useTranslation } from "react-i18next";

function Page4() {
  const { t } = useTranslation("New");

  return (
    <div className="w-full flex flex-col gap-4 items-center">
      <div className="w-[500px] h-[250px]">
        <img src={TutorialImage4} alt="tutorial" className="w-full h-full" />
      </div>

      <div className="flex flex-col gap-4 mt-7">
        <p className="font-medium text-center">{t("onboardingDesc4")}</p>
      </div>
    </div>
  );
}

export default Page4;
